var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlphaSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "alpha-circle",
    "data-name": "Flat Line",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-line",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "secondary",
    cx: 12,
    cy: 12,
    r: 9,
    style: {
      fill: "#0B3954",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    id: "primary",
    cx: 12,
    cy: 12,
    r: 9,
    style: {
      fill: "none",
      stroke: "#BFD7EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary-2",
    "data-name": "primary",
    d: "M15.56,9.43S13.89,15,10.7,15c-1.92,0-2.87-1.1-2.65-2.56C8.29,10.79,9.66,9,11.31,9c3.1,0,1.78,6,4.69,6",
    style: {
      fill: "none",
      stroke: "#BFD7EA",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphaSvg);
export default __webpack_public_path__ + "static/media/AlphaSVG.81f812078161d544d159be34bda48754.svg";
export { ForwardRef as ReactComponent };